import request from './request'

// 订单服务费分配记录接口
export function getOrderCommissionAllocations(orderId, params = {}) {
  return request({
    url: '/admin/commission-allocations',
    method: 'get',
    params: {
      order_id: orderId,
      ...params
    }
  })
}
